var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('device-statistics-analogue-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.options,"height":250}})}
var staticRenderFns = []

export { render, staticRenderFns }